<div class="banner-container">
  <div
    class="banner-image flex-column align-items-center justify-content-end d-none d-lg-flex"
    [style.background-image]="'url(' + banner.imageUrl + ')'"
  >
    <img *ngIf="showLogo" class="logo" src="/assets/image/into-the-wild-logo.png" />
    <h1 class="text-light banner-text" [innerHTML]="banner.title"></h1>
  </div>
  <div
    class="banner-image d-none d-sm-flex d-lg-none flex-column align-items-center justify-content-end"
    [style.background-image]="'url(' + banner.tabletImageUrl + ')'"
  >
    <img *ngIf="showLogo" class="logo" src="/assets/image/into-the-wild-logo.png" />
    <h1 class="text-light banner-text" [innerHTML]="banner.title"></h1>
  </div>
  <div
    class="banner-image d-sm-none d-flex flex-column align-items-center justify-content-end"
    [style.background-image]="'url(' + banner.mobileImageUrl + ')'"
  >
    <img *ngIf="showLogo" class="logo" src="/assets/image/into-the-wild-logo.png" />
    <h1 class="text-light banner-text" [innerHTML]="banner.title"></h1>
  </div>
</div>
